import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import Api from './../../../Global/Modules/Api'

class Werkervaring extends Component {
    constructor(props) {
        super(props)
        this.getWorkingExperiences = this.getWorkingExperiences.bind(this)
        this.getPoints = this.getPoints.bind(this)
    }

    getPoints() {
        let data = this.props.data

        if (data) {
            Api.print("Get points")
            let c4minus = data.c4minus
            let c4plus = data.c4plus
            let o = data.o
            let cC1andCC2 = data.cC1andCC2
            let cC2bandCC3 = data.cC2bandCC3
            let total = data.total

            return <tbody>
                {c4minus[1] > 0 ?
                    <tr key='c4minus'>
                        <td colSpan="7"><strong>C4- ee's</strong></td>
                        <td><strong>{c4minus[0]}</strong></td>
                        <td><strong>{c4minus[1]}</strong></td>
                        <td><strong>{c4minus[2]}</strong></td>
                        <td colSpan="5">&nbsp;</td>
                    </tr> : ""}
                {c4plus[1] > 0 ?
                    <tr key='c4plus'>
                        <td colSpan="7"><strong>C4+ ee's</strong></td>
                        <td><strong>{c4plus[0]}</strong></td>
                        <td><strong>{c4plus[1]}</strong></td>
                        <td><strong>{c4plus[2]}</strong></td>
                        <td colSpan="5">&nbsp;</td>
                    </tr> : ""}
                {o[1] > 0 ?
                    <tr key='o'>
                        <td colSpan="7"><strong>O ee's</strong></td>
                        <td><strong>{o[0]}</strong></td>
                        <td><strong>{o[1]}</strong></td>
                        <td><strong>{o[2]}</strong></td>
                        <td colSpan="5">&nbsp;</td>
                    </tr>
                    : ""
                }
                {cC1andCC2[1] > 0 ?
                    <tr key='cC1andCC2'>
                        <td colSpan="7"><strong>CC1 & CC2a ee's</strong></td>
                        <td><strong>{cC1andCC2[0]}</strong></td>
                        <td><strong>{cC1andCC2[1]}</strong></td>
                        <td><strong>{cC1andCC2[2]}</strong></td>
                        <td colSpan="5">&nbsp;</td>
                    </tr> : ""}
                {cC2bandCC3[1] > 0 ?
                    <tr key='cC2bandCC3'>
                        <td colSpan="7"><strong>CC2b & CC3 ee's</strong></td>
                        <td><strong>{cC2bandCC3[0]}</strong></td>
                        <td><strong>{cC2bandCC3[1]}</strong></td>
                        <td><strong>{cC2bandCC3[2]}</strong></td>
                        <td colSpan="5">&nbsp;</td>
                    </tr> : ""}

                <tr key='total'>
                    <td colSpan="7"><strong>Totaal ee's</strong></td>
                    <td><strong>{total[0]}</strong></td>
                    <td><strong>{total[1]}</strong></td>
                    <td><strong>{total[2]}</strong></td>
                    <td colSpan="5">&nbsp;</td>

                </tr>
            </tbody>
        }

        return null
    }

    getWorkingExperiences() {
        let data = this.props.data
        return data ? data.workingExperiences.map((wE, index) => {
            return <tbody>
                <tr key={index}>
                    <td>{wE.level}</td>
                    <td>{wE.company}</td>
                    <td>{wE.customer}</td>
                    <td>{wE.projectType}</td>
                    <td>{wE.project}</td>
                    <td>{wE.city}</td>
                    <td>{wE.years}</td>
                    <td>{wE.hours}</td>
                    <td>{wE.ee}</td>
                    <td>{wE.imported}</td>
                    <td>{wE.reference}</td>
                    <td>{wE.approved}</td>
                    <td>{wE.upload}</td>
                    <td>{wE.description}</td>
                </tr>
            </tbody>
        }) : null
    }

    render() {
        return (
            <div className="rapport">
                <h5><strong>{this.props.permanent ? "Doorlopende Werkervaring" : "Werkervaring"}</strong></h5>
                <Table responsive bordered className="werkervaring">
                    <thead>
                        <tr>
                            <th>Niveau</th>
                            <th>Werkgever</th>
                            <th>Opdrachtgever</th>
                            <th>Soort project</th>
                            <th>Project</th>
                            <th>Locatie</th>
                            <th>Jaar</th>
                            <th>Uren</th>
                            <th>Ingevoerde ee's</th>
                            <th>Ee's akkoord</th>
                            <th>Referentie</th>
                            <th>Goedgekeurd op</th>
                            <th>Upload</th>
                            <th>Omschrijving project</th>
                            <th>Omschrijving werkzaamheden</th>
                        </tr>
                    </thead>
                    {this.getWorkingExperiences()}
                    {this.getPoints()}
                </Table>
            </div>
        );
    }
}

export default Werkervaring;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Rapport/Werkervaring.js